import React, { Component } from "react";
import { connect } from "react-redux";
import { check } from "@xams-utils/check-types";

import {withMessages} from 'components/hocs/messages'

import { settingsApi } from "libs/api/interface/api-settings";
import { getSessionData } from "redux/reducers/selectors";
import {
    getMfaData,
    getClientSessionData,
    getUserSessionData,
} from "redux/reducers/session/selectors";
import {
    getMfaRequired,
    getMfaOption,
} from "redux/reducers/session/mfa/selectors";
import { getOrgId } from "redux/reducers/session/client/selectors";
import { getUserId, getEmail } from "redux/reducers/session/user/selectors";

import { MfaNotEnabled } from "./mfa-not-enabled";
import { MfaEnabled } from "./mfa-enabled";

import { MFA_STATES } from "constants/multi-factor-authentication";

import withStyles from "@material-ui/core/styles/withStyles";
import Card from "@material-ui/core/Card";

import { styles } from "components/pages/login/form/form-styles";
import { checkRememberMe, saveRememberMe } from "./remember-me";

class MultiFactorAuthenticator extends Component {
    state = { displayState: null, rememberMeDays:0 };

    componentDidMount() {
        const { mfaOption, mfaRequired, onSuccess, orgId, userId } = this.props;

        if (!mfaRequired) {
            onSuccess();
        }
        else{
            if (mfaOption === 0 && checkRememberMe({userId, orgId})){
                saveRememberMe(false, { userId, orgId });
            }

            const displayState =
            mfaOption === 0 ? MFA_STATES.ENABLE : MFA_STATES.VERIFY;
            let rememberMeDays=0;

            settingsApi
                .getMfaRememberMeDays(orgId)
                .then((response) => {
                    if (check.nonEmptyString(response)) {
                        const parsedResponse = JSON.parse(response);

                        if (check.nonEmptyObject(parsedResponse)) {
                            const { value } = parsedResponse;

                            if (check.nonEmptyString(value)) {
                                const intValue=parseInt(value)
                                    if (check.number(intValue)){
                                        rememberMeDays=intValue
                                    }
                            }
                        }
                    }


                    this.setState({ displayState, rememberMeDays });
                })
                .catch(() => {
                    this.setState({ displayState });
                });
            }
    }

    componentDidUpdate(prevProps) {
        const { mfaOption: prevMfaOption } = prevProps;
        const { mfaOption } = this.props;

        if (mfaOption !== prevMfaOption) {
            const displayState =
                mfaOption === 0 ? MFA_STATES.ENABLE : MFA_STATES.VERIFY;

            this.setState({ displayState });
        }
    }

    displayState(props) {
        const { displayState } = this.state;

        if (displayState === MFA_STATES.ENABLE) {
            return <MfaNotEnabled {...props} />;
        } else if (displayState === MFA_STATES.VERIFY) {
            return <MfaEnabled {...props} />;
        }

        return null;
    }

    render() {
        const { displayState, rememberMeDays } = this.state;

        if (!displayState) {
            return null;
        }

        const { mfaOption, onSuccess, orgId, userId, classes, userEmail, messages } = this.props;

        const props = {
            onVerify: onSuccess,
            mfaOption,
            orgId,
            userId,
            userEmail,
            classes,
            rememberMeDays,
            messages
        };

        // return <div>{this.displayState(props)}</div>;

        return (
            <div className={classes.layout}>
                <Card
                    raised
                    className={classes.card}
                >
                    {this.displayState(props)}
                </Card>
            </div>
        );
    }
}

const mapStoreToProps = (store) => {
    const sessionData = getSessionData(store);

    const mfaData = getMfaData(sessionData);
    const mfaRequired = getMfaRequired(mfaData);
    const mfaOption = mfaRequired ? getMfaOption(mfaData) : null;

    const clientSessionData = getClientSessionData(sessionData);
    const orgId = getOrgId(clientSessionData);

    const userSessionData = getUserSessionData(sessionData);
    const userId = getUserId(userSessionData);
    const userEmail = getEmail(userSessionData);

    return { mfaRequired, mfaOption, orgId, userId, userEmail };
};

MultiFactorAuthenticator = connect(mapStoreToProps)(MultiFactorAuthenticator);

MultiFactorAuthenticator = withStyles(styles)(MultiFactorAuthenticator);

MultiFactorAuthenticator = withMessages(MultiFactorAuthenticator);

export { MultiFactorAuthenticator };
